var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "install-create" },
    [
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.isEdit ? "编辑安装工单" : "创建安装工单")),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { float: "right", padding: "3px 0" },
                  attrs: { type: "text" },
                  on: { click: _vm.goBack },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "div",
                { staticClass: "install-no-section" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "安装单据号" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "250px" },
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.form.installCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "installCode", $$v)
                          },
                          expression: "form.installCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("span", [_vm._v("订单信息")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "section-stats" }, [
                    _vm._v(
                      " 已选择 " +
                        _vm._s(_vm.checkedOrderSolutions.length) +
                        " 个订单方案 "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.tableLoading,
                        expression: "tableLoading",
                      },
                    ],
                    attrs: {
                      "element-loading-text": "加载订单数据中...",
                      "element-loading-spinner": "el-icon-loading",
                      "element-loading-background": "rgba(255,255,255,0.85)",
                    },
                  },
                  [
                    !_vm.tableLoading
                      ? [
                          _c(
                            "el-table",
                            {
                              ref: "contractTable",
                              staticStyle: {
                                width: "100%",
                                "margin-bottom": "20px",
                                "font-size": "16px",
                              },
                              attrs: {
                                data: _vm.contractList,
                                "max-height": _vm.tableHeight,
                                "header-cell-style": {
                                  backgroundColor: "#e8eaed",
                                  color: "#333",
                                  fontWeight: "bold",
                                },
                                "cell-style": {
                                  paddingBottom: "8px",
                                  paddingTop: "8px",
                                },
                                border: "",
                                "row-key": "contractId",
                                type: "expand",
                              },
                              on: {
                                "selection-change":
                                  _vm.handleContractMainSelectionChange,
                                "row-click": _vm.handleMainRowClick,
                                "expand-change":
                                  _vm.handleContractMainExpandChange,
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "selection",
                                  width: "50",
                                  "reserve-selection": true,
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { type: "expand" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.designSchemes &&
                                          scope.row.designSchemes.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "20px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-table",
                                                    {
                                                      ref:
                                                        "designSchemeTable_" +
                                                        scope.row.contractId,
                                                      staticStyle: {
                                                        width:
                                                          "calc(100% - 20px)",
                                                        "font-size": "14px",
                                                      },
                                                      attrs: {
                                                        data: scope.row
                                                          .designSchemes,
                                                        size: "small",
                                                        "header-cell-style": {
                                                          backgroundColor:
                                                            "#e8eaed",
                                                          color: "#333",
                                                          fontWeight: "bold",
                                                        },
                                                        border: "",
                                                        "row-key": "id",
                                                        type: "expand",
                                                      },
                                                      on: {
                                                        "selection-change":
                                                          _vm.handleDesignSchemeSelectionChange,
                                                        "row-click":
                                                          _vm.handleDesignSchemeRowClick,
                                                        "expand-change":
                                                          _vm.handleDesignSchemeExpandChange,
                                                      },
                                                    },
                                                    [
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          type: "selection",
                                                          width: "50",
                                                          "reserve-selection": true,
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          type: "expand",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function (
                                                                designScope
                                                              ) {
                                                                return [
                                                                  designScope
                                                                    .row
                                                                    .orderSolutions &&
                                                                  designScope
                                                                    .row
                                                                    .orderSolutions
                                                                    .length > 0
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "margin-left":
                                                                                "20px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "el-table",
                                                                            {
                                                                              ref:
                                                                                "orderSolutionTable_" +
                                                                                designScope
                                                                                  .row
                                                                                  .id,
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100%",
                                                                                  "font-size":
                                                                                    "13px",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  data: designScope
                                                                                    .row
                                                                                    .orderSolutions,
                                                                                  size: "small",
                                                                                  "header-cell-style":
                                                                                    {
                                                                                      backgroundColor:
                                                                                        "#e8eaed",
                                                                                      color:
                                                                                        "#333",
                                                                                      fontWeight:
                                                                                        "bold",
                                                                                    },
                                                                                  "cell-style":
                                                                                    {
                                                                                      backgroundColor:
                                                                                        "#FFF",
                                                                                    },
                                                                                  border:
                                                                                    "",
                                                                                  "row-key":
                                                                                    "id",
                                                                                },
                                                                              on: {
                                                                                "selection-change":
                                                                                  _vm.handleOrderSolutionSelectionChange,
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "el-table-column",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      type: "selection",
                                                                                      width:
                                                                                        "50",
                                                                                      "reserve-selection": true,
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "el-table-column",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      prop: "solutionName",
                                                                                      label:
                                                                                        "生产分类",
                                                                                      "min-width":
                                                                                        "120",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "el-table-column",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      prop: "packages",
                                                                                      label:
                                                                                        "包数",
                                                                                      "min-width":
                                                                                        "80",
                                                                                    },
                                                                                }
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "el-table-column",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      prop: "area",
                                                                                      label:
                                                                                        "面积",
                                                                                      "min-width":
                                                                                        "80",
                                                                                    },
                                                                                  scopedSlots:
                                                                                    _vm._u(
                                                                                      [
                                                                                        {
                                                                                          key: "default",
                                                                                          fn: function (
                                                                                            sRow
                                                                                          ) {
                                                                                            return [
                                                                                              _c(
                                                                                                "span",
                                                                                                [
                                                                                                  _vm._v(
                                                                                                    _vm._s(
                                                                                                      sRow
                                                                                                        .row
                                                                                                        .area ||
                                                                                                        0
                                                                                                    ) +
                                                                                                      " m²"
                                                                                                  ),
                                                                                                ]
                                                                                              ),
                                                                                            ]
                                                                                          },
                                                                                        },
                                                                                      ],
                                                                                      null,
                                                                                      true
                                                                                    ),
                                                                                }
                                                                              ),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      )
                                                                    : _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              color:
                                                                                "#909399",
                                                                              "text-align":
                                                                                "center",
                                                                              padding:
                                                                                "20px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "暂无订单方案"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          prop: "productionOrder",
                                                          label: "销售单号",
                                                          "min-width": "140",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c("el-table-column", {
                                                        attrs: {
                                                          label: "总包数量",
                                                          "min-width": "140",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function (
                                                                dRow
                                                              ) {
                                                                return [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.getDesignSchemeTotalPackages(
                                                                          dRow.row
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    color: "#909399",
                                                    "text-align": "center",
                                                    padding: "20px",
                                                  },
                                                },
                                                [_vm._v("暂无设计方案")]
                                              ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  755058033
                                ),
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "contractNumber",
                                  label: "合同号",
                                  "min-width": "180",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "custName",
                                  label: "客户名称",
                                  "min-width": "120",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "custMobile",
                                  label: "客户手机",
                                  "min-width": "130",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "custAddress",
                                  label: "客户地址",
                                  "min-width": "200",
                                  "show-overflow-tooltip": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "reserveInstallDate",
                                  label: "预约安装时间",
                                  "min-width": "160",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: "统计",
                                  "min-width": "120",
                                  align: "left",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "总包数: " +
                                                  _vm._s(
                                                    _vm.getContractTotalPackages(
                                                      scope.row
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-tag",
                                            {
                                              staticStyle: {
                                                "margin-left": "6px",
                                              },
                                              attrs: {
                                                type: "primary",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "总方数: " +
                                                  _vm._s(
                                                    _vm.getContractTotalArea(
                                                      scope.row
                                                    )
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  4126834243
                                ),
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "table-note" }, [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(
                    " 提示：取消勾选的订单方案将不包含在此次安装中\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-section total-summary-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _vm._v("订单总计"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-cards" }, [
                  _c("div", { staticClass: "summary-card" }, [
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v("订单方案数量"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(_vm._s(_vm.checkedOrderSolutions.length) + " 个"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-card" }, [
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v("包裹总数"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(_vm._s(_vm.totalPackages) + " 包"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-card" }, [
                    _c("div", { staticClass: "card-label" }, [
                      _vm._v("总面积"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-value" }, [
                      _vm._v(_vm._s(_vm.totalArea.toFixed(2)) + " m²"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("安装信息"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "customer" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("收货人"),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { placeholder: "请输入收货人" },
                                model: {
                                  value: _vm.form.customer,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "customer", $$v)
                                  },
                                  expression: "form.customer",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "customerPhone" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("收货人电话"),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { placeholder: "请输入收货人电话" },
                                model: {
                                  value: _vm.form.customerPhone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "customerPhone", $$v)
                                  },
                                  expression: "form.customerPhone",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "customerAddress" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("收货地址"),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { placeholder: "请输入收货地址" },
                                model: {
                                  value: _vm.form.customerAddress,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "customerAddress", $$v)
                                  },
                                  expression: "form.customerAddress",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "coordinate" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("定位"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { flex: "1" },
                                    attrs: { placeholder: "请输入坐标" },
                                    model: {
                                      value: _vm.form.coordinate,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "coordinate", $$v)
                                      },
                                      expression: "form.coordinate",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-button", {
                                    staticStyle: {
                                      "margin-left": "5px",
                                      padding: "9px",
                                    },
                                    attrs: { icon: "el-icon-location" },
                                    on: { click: _vm.openMapSelector },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "installDate" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("上门日期"),
                              ]),
                              _vm._v(" "),
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd",
                                  "picker-options": _vm.pickerOptions,
                                },
                                model: {
                                  value: _vm.form.installDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "installDate", $$v)
                                  },
                                  expression: "form.installDate",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "installTime" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("上门时间"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择时间" },
                                  model: {
                                    value: _vm.form.installTime,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "installTime", $$v)
                                    },
                                    expression: "form.installTime",
                                  },
                                },
                                _vm._l(
                                  _vm.dict.delivery_install_time_slot,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "productType" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("产品类型"),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { placeholder: "请输入产品类型" },
                                model: {
                                  value: _vm.form.productType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "productType", $$v)
                                  },
                                  expression: "form.productType",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "isIn" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("是否入住"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "请选择" },
                                  model: {
                                    value: _vm.form.isIn,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "isIn", $$v)
                                    },
                                    expression: "form.isIn",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "是", value: true },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "否", value: false },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "installPerson" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("安装师傅"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    gap: "8px",
                                  },
                                },
                                [
                                  _vm.installPersonName
                                    ? _c("el-tag", [
                                        _vm._v(_vm._s(_vm.installPersonName)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.onSelectPerson } },
                                    [_vm._v("选择")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "installGroup" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("安装组长"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    gap: "8px",
                                  },
                                },
                                [
                                  _vm.installGroupName
                                    ? _c("el-tag", [
                                        _vm._v(_vm._s(_vm.installGroupName)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.onSelectGroup } },
                                    [_vm._v("选择")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "installMamager" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("安装主管"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    gap: "8px",
                                  },
                                },
                                [
                                  _vm.installManagerName
                                    ? _c("el-tag", [
                                        _vm._v(_vm._s(_vm.installManagerName)),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.onSelectManager } },
                                    [_vm._v("选择")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "openWay" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("开门方式"),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: { placeholder: "请输入开门方式" },
                                model: {
                                  value: _vm.form.openWay,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "openWay", $$v)
                                  },
                                  expression: "form.openWay",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "openRemark" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("开门备注"),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  placeholder: "请输入开门备注",
                                },
                                model: {
                                  value: _vm.form.openRemark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "openRemark", $$v)
                                  },
                                  expression: "form.openRemark",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "remark" } },
                            [
                              _c("template", { slot: "label" }, [
                                _vm._v("备注"),
                              ]),
                              _vm._v(" "),
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  placeholder: "请输入备注",
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _c("span", [_vm._v("安装运力情况")]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "auto",
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: {
                            width: "150px",
                            "margin-right": "10px",
                          },
                          attrs: {
                            type: "date",
                            placeholder: "选择日期",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: {
                            change: function () {
                              return _vm.loadInstallerList()
                            },
                          },
                          model: {
                            value: _vm.installerSearchDate,
                            callback: function ($$v) {
                              _vm.installerSearchDate = $$v
                            },
                            expression: "installerSearchDate",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-refresh" },
                            on: {
                              click: function ($event) {
                                return _vm.loadInstallerList()
                              },
                            },
                          },
                          [_vm._v("刷新")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.installerLoading,
                          expression: "installerLoading",
                        },
                      ],
                      ref: "scheduleTable",
                      staticStyle: {
                        width: "100%",
                        "margin-bottom": "20px",
                        "font-size": "16px",
                      },
                      attrs: {
                        data: _vm.pagedScheduleList,
                        border: "",
                        "max-height": _vm.tableHeight,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "安装师傅",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.scheduleDateRange, function (dateItem) {
                        return _c(
                          "el-table-column",
                          {
                            key: dateItem.key,
                            attrs: { label: dateItem.label, align: "center" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: "上午",
                                "min-width": "80",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.getScheduleClass(
                                              scope.row[dateItem.key + "_上午"]
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[
                                                  dateItem.key + "_上午"
                                                ] || "空闲"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "下午",
                                "min-width": "80",
                                align: "center",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: _vm.getScheduleClass(
                                              scope.row[dateItem.key + "_下午"]
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                scope.row[
                                                  dateItem.key + "_下午"
                                                ] || "空闲"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.scheduleTotal > 0
                    ? _c("el-pagination", {
                        staticStyle: {
                          "margin-top": "15px",
                          "text-align": "right",
                        },
                        attrs: {
                          "current-page": _vm.schedulePagination.page,
                          "page-sizes": [10, 20, 50, 100],
                          "page-size": _vm.schedulePagination.pageSize,
                          total: _vm.scheduleTotal,
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.handleScheduleSizeChange,
                          "current-change": _vm.handleScheduleCurrentChange,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-footer" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.isSubmitting },
                      on: {
                        click: function ($event) {
                          return _vm.handleSave(10)
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.isSubmitting },
                      on: {
                        click: function ($event) {
                          return _vm.handleSave(0)
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "选择位置",
                visible: _vm.mapDialogVisible,
                width: "800px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.mapDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "10px",
                    position: "relative",
                    width: "70%",
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请输入地址关键词搜索" },
                      on: { input: _vm.handleSearchInput },
                      model: {
                        value: _vm.searchKeyword,
                        callback: function ($$v) {
                          _vm.searchKeyword = $$v
                        },
                        expression: "searchKeyword",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.searchLocation },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showSearchResults && _vm.searchResults.length > 0
                    ? _c(
                        "div",
                        { staticClass: "search-results" },
                        _vm._l(_vm.searchResults, function (result, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "search-result-item",
                              on: {
                                click: function ($event) {
                                  return _vm.selectSearchResult(result)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-location" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(result.name) +
                                    _vm._s(
                                      result.address ? " " + result.address : ""
                                    )
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticStyle: { width: "100%", height: "500px" },
                attrs: { id: "mapContainer" },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.mapDialogVisible = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmMapSelection },
                    },
                    [_vm._v("确认选择")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("UserSelect", {
        ref: "userSelect",
        attrs: { "show-user-select": _vm.showUserSelect },
        on: {
          close: _vm.onSelectUserClose,
          "select-user-callBack": _vm.selectUserCallBack,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }